import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "icon"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "icon text-primary"
}
const _hoisted_4 = ["innerHTML"]

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBoltLightning, faFireFlameCurved } from '@fortawesome/pro-light-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseIconButton',
  props: {
  icon: String,
  customIcon: String,
  image: [String, Object],
  svg: String,
  color: {
    type: String,
    default: 'primary',
  },
  inverted: Boolean,
  small: Boolean,
},
  setup(__props) {

library.add(faBoltLightning);
library.add(faFireFlameCurved);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["base-button--icon", {
        [__props.color]: true,
        'no-icon': !(__props.icon || __props.svg || __props.customIcon),
        'inverted': __props.inverted,
        'small': __props.small,
      }])
  }, [
    (__props.customIcon)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.customIcon.startsWith('fa'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createElementVNode("i", {
                  class: _normalizeClass(__props.customIcon)
                }, null, 2)
              ]))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "icon-svg",
                innerHTML: __props.customIcon
              }, null, 8, _hoisted_2))
        ], 64))
      : _createCommentVNode("", true),
    (!__props.customIcon)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (__props.icon)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createVNode(_unref(FontAwesomeIcon), { icon: __props.icon }, null, 8, ["icon"])
              ]))
            : (__props.svg)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "icon-svg",
                  innerHTML: __props.svg
                }, null, 8, _hoisted_4))
              : (__props.image)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    class: "image",
                    style: _normalizeStyle({ backgroundImage: __props.image.url || __props.image })
                  }, null, 4))
                : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})